/**
* @Author: zachalam
* @Date:   2017-01-19T17:00:10-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:00:44-08:00
*/

import React, { Component } from 'react';
import SearchResults from '../components/pages/Search/SearchResults';
import { connect } from 'react-redux';
import { clearSearch, profileSearch, tripSearch, resetFilters, resetIndividualFilter, saveFilters, storeProfileSearchFavChange, getTripDestinationPhoto } from '../actions/searchActions';
import { favToggle } from '../actions/favActions';
import { storeTripSearchTripJoin, joinTrip } from '../actions/tripActions';
import { refreshAccount } from '../actions/profileActions';
import { storeMeta } from '../actions/metaActions';

class SearchResultsContainer extends Component {

  componentDidMount() {
    // scroll to last height.
    window.scrollTo(0,this.props.scrollHeight);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = (e) => {
      let scrollTop = (e.srcElement || e.target).body.scrollTop;
      this.props.saveScroll(scrollTop);
  }

  render() {
    return (
      <SearchResults handleScroll={this.handleScroll} {...this.props} />
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    search: state.search,
    moreExists: Boolean(state.meta.search_current_page < state.meta.search_total_pages),
    scrollHeight: state.meta.search_scroll_height,
    destinationPhoto: state.search.destinationPhoto
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    saveScroll: (search_scroll_height) => {
      dispatch(storeMeta({search_scroll_height}));
    },
    refreshProfile: (formData) => {
      // initial state
      dispatch(clearSearch());
      dispatch(profileSearch(formData));
      // also refresh account (for header counts).
      dispatch(refreshAccount());
    },

    refreshTrips: (formData) => {
      dispatch(clearSearch());
      dispatch(tripSearch(formData));
      // also refresh account (for header counts).
      dispatch(refreshAccount());

    },
    resetFilters: () => {
      dispatch(resetFilters());
    },
    resetIndividualFilter: (filterType) => {
      dispatch(resetIndividualFilter(filterType));
    },
    favToggle: (username,favKey) => {
      // notify store (search)
      dispatch(storeProfileSearchFavChange(favKey));
      // notify api
      dispatch(favToggle(username));
    },
    joinTrip: (tripId,tripKey) => {
      // notify store
      dispatch(storeTripSearchTripJoin(tripKey));
      // notify api.
      dispatch(joinTrip(tripId));
    },
    saveFilters: (filters) => {
      dispatch(saveFilters(filters));
    },

    loadMore: (profile=true, formData) => {
      // get more paginated results.
      if(profile) dispatch(profileSearch(formData,false));
      else dispatch(tripSearch(formData,false));
    },

    getTripDestinationPhoto: (lat, lng) => {
      dispatch(getTripDestinationPhoto(lat, lng))
    }
  }
}

export default connect(mapStateTopProps,mapDispatchToProps)(SearchResultsContainer);



// WEBPACK FOOTER //
// ./src/containers/SearchResultsContainer.jsx